import { mapGetters } from "vuex";
import FindifyPageTracking from "../mixins/FindifyPageTracking";
import StoryBlokPreview from "../mixins/storyblok-live-preview";
import * as imgproxy from "@made-people/imgproxy";

export default {
  name: "Storyblok",
  mixins: [StoryBlokPreview, FindifyPageTracking],
  props: {
    languageCode: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      meta: {
        title: "",
        meta: [],
        canonical: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      getStoryById: "storyblok/getStoryById",
      settings: "storyblok/settings",
    }),
    page() {
      return this.getStoryById(this.id) || this.data;
    },
  },
  created() {
    return this.setMeta();
  },
  serverPrefetch() {
    if (this.page.content.centraCampaignSite) {
      this.$store.dispatch(
        "frontend/setCurrentCampaignUri",
        this.page.content.centraCampaignSite
      );
    }
  },
  mounted() {
    this.gtm_trackPage(
      this.page.slug === "site" ? "home" : "other",
      this.meta.title
    );
    this.findify_trackPageView();
  },
  methods: {
    setMeta() {
      if (this.page && this.page.content.seo) {
        const blok = this.page.content;
        const description =
          blok.seo.description ||
          (this.settings?.default_meta_description ?? "");
        const canonical =
          this.$config.baseUrl +
          (blok.canonical ? this.$u(blok.canonical) : this.$route.path);
        const meta = [
          {
            hid: "description",
            name: "description",
            content: description,
          },
          {
            hid: "og:title",
            property: "og:title",
            content: blok.seo.og_title || blok.seo.title || this.page.name,
          },
          {
            hid: "og:description",
            property: "og:description",
            content: blok.seo.og_description || description,
          },
          { hid: "og:url", property: "og:url", content: canonical },
          { hid: "og:type", property: "og:type", content: "website" },
          {
            hid: "og:site_name",
            property: "og:site_name",
            content: this.$config.site.name,
          },
        ];

        const robots = blok.metaRobots || null;
        if (robots && robots.length) {
          meta.push({
            hid: "robots",
            name: "robots",
            content: robots.join(","),
          });
        }

        const ogImage =
          blok.seo.og_image || this.settings?.openGraphImage?.filename || null;
        if (ogImage) {
          const resizedImage = this.getImageUrl(ogImage);
          meta.push({
            hid: "og:image",
            content: resizedImage,
            property: "og:image",
          });
        }

        const metaTitle = blok.seo.title || this.page.name;
        this.meta.title =
          (this.settings?.meta_title_prefix ?? "") +
          metaTitle +
          (this.settings?.meta_title_suffix ?? "");
        this.meta.meta = meta;
        this.meta.canonical = canonical;
      }
    },
    getImageUrl(image) {
      imgproxy.useBaseUrl(this.$config.imageProxyUrl);
      return imgproxy.transform(image, "resize:fill/w:1200/h:630/g:sm/q:70");
    },
    getUrl() {
      if (this.$store.state.route.query._storyblok) {
        // Browsing in SB
        return this.$store.state.route.query._storyblok;
      }

      let route = this.$route.path.replace(/^\//, "");
      route = route === "" ? "home" : route;
      route = route.replace(/^[\w-]+\/?/, "site/");
      return route;
    },
  },
  head() {
    return {
      title: this.meta.title,
      meta: this.meta.meta,
      link: [
        {
          rel: "canonical",
          href: this.meta.canonical,
        },
      ],
    };
  },
};
